
import React, { useEffect, useState } from 'react';
import './dialogcontacts.css';
import axios from 'axios';
import { toast } from 'react-hot-toast';

function DialogContacts({ isOpen, onClose }) {
  const [apiUrl, setApiUrl] = useState('');
  const [contacts, setContacts] = useState({
    whatsapp: '',
    telegram: ''
  });

  
  useEffect(() => {
    fetch('/templates/api.txt')
      .then((res) => res.text())
      .then((data) => {
        setApiUrl(data.trim());
      })
      .catch((err) => console.error('Ошибка при загрузке API URL:', err));
  }, []);

  
  useEffect(() => {
    if (isOpen && apiUrl) {
      const fetchContacts = async () => {
        try {
          const response = await axios.get(`${apiUrl}api/info`);
          setContacts({
            whatsapp: response.data.whatsapp || '',
            telegram: response.data.telegram || ''
          });
        } catch (error) {
          console.error('Ошибка при загрузке контактных данных:', error);
          toast.error('Не удалось загрузить контактные данные. Попробуйте позже.');
        }
      };
      fetchContacts();
    }
  }, [isOpen, apiUrl]);

  
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [isOpen]);

  
  if (!isOpen) {
    return null;
  }

  return (
    <div className="dialogcontacts-overlay">
      <div className="dialogcontacts-content">
        <button className="dialogcontacts-close" onClick={onClose}>
          &times;
        </button>
        <h2 className="dialogcontacts-title">Контакты</h2>
        <div className="dialogcontacts-buttons">
          {contacts.whatsapp && (
            <a
              href={`https://wa.me/${contacts.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              className="dialogcontacts-button"
            >
              WhatsApp
            </a>
          )}
          {contacts.telegram && (
            <a
              href={`https://t.me/${contacts.telegram}`}
              target="_blank"
              rel="noopener noreferrer"
              className="dialogcontacts-button"
            >
              Telegram
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default DialogContacts;
